import { createAsyncThunk } from '@reduxjs/toolkit';
import { get, post } from '../models/base';

export const saveVideoLink = createAsyncThunk(
  'videos/saveVideoLink',
  async (link, { rejectWithValue, getState }) => {
    const { album } = getState().album;
    const { folder } = getState().folders;

    try {
      const queryPath = `/albums/${album.id}/folders/${folder.id}/videos`;
      const response = await post(queryPath, {
        video: {
          url: link,
          video_type: 'youtube',
        },
      });

      return response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);

export const fetchVideos = createAsyncThunk(
  'videos/fetchVideos',
  async (folderId, { rejectWithValue, getState }) => {
    const { albumId } = getState().album;
    const { folders } = getState().folders;
    folderId = folderId || folders[0].id;

    try {
      const queryPath = `/albums/${albumId}/folders/${folderId}/videos`;
      const response = await get(queryPath);
      return response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);
